<template>
  <div class="sidebar column">
    <img class="logo" src="@/assets/img/siderBar/logo.png" alt="" />
    <div class="menu column">
      <div
        class="menu_item flex"
        :class="{ active_menu_item: activeMenu.name == item.name }"
        v-for="item in menu_list"
        :key="item.name"
        @click="goMenu(item)"
      >
        <img :src="item.icon" :alt="item.name" />
      </div>
    </div>
    <div class="avatar_con">
      <img
        @click="goPersonalCenter"
        class="avatar"
        :src="
          userInfo?.loginUser?.avatar
            ? userInfo?.loginUser?.avatar
            : require('@/assets/img/siderBar/logo.png')
        "
        alt=""
      />
      <div class="hover_back">
        <div class="hover_list">
          <div class="list_item" @click.stop="goPersonalCenter">个人中心</div>
          <div class="list_item" @click.stop="logout">退出登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOut } from "@/assets/js/request";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      activeMenu: {
        name: "首页",
        path: "/",
        icon: require("@/assets/img/siderBar/home.svg"),
      },
      menu_list: [
        {
          name: "首页",
          path: "/",
          icon: require("@/assets/img/siderBar/home.svg"),
        },
        {
          name: "作品集",
          path: "/workManagement",
          icon: require("@/assets/img/siderBar/portfolio.svg"),
        },
        {
          name: "消息",
          path: "/messageCenter",
          icon: require("@/assets/img/siderBar/message.svg"),
        },
      ],
    };
  },
  watch: {
    $route(newVal, oldVal) {
      for (let i = 0; i < this.menu_list.length; i++) {
        if (newVal.path == this.menu_list[i].path) {
          this.activeMenu = this.menu_list[i];
          break;
        }
      }
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    changeToggle(index) {
      this.menu_list[index].showChildList =
        !this.menu_list[index].showChildList;
    },
    goMenu(item) {
      if (this.$route.fullPath == item.path) {
        this.$router.go(0);
        return;
      }
      this.activeMenu = item;
      this.$router.push(item.path);
    },
    goPersonalCenter() {
      if (location.href.includes("/personalCenter")) {
        location.reload;
        return;
      }
      this.$router.push("/personalCenter");
      this.activeMenu = {
        name: "",
        path: "",
        icon: "",
      };
    },
    logout() {
      loginOut({ token: localStorage.getItem("token") });
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100vh;
  width: 68px;
  background: #ffffff;
  border-right: 1px solid #eeeeee;
  align-items: center;
  flex-shrink: 0;
  position: sticky;
  z-index: 10;
  top: 0;
  left: 0;
  .logo {
    width: 32px;
    height: 32px;
    margin-top: 32px;
    margin-bottom: 40px;
  }
  .menu {
    align-items: center;
    .menu_item {
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .active_menu_item {
      background: #9bdb4a;
    }
  }
  .avatar_con {
    margin-top: auto;
    position: relative;
    z-index: 2;
    &:hover {
      .hover_back {
        display: block;
      }
    }
    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-bottom: 24px;
      cursor: pointer;
    }
    .no_avatar {
      background: #dedede;
    }
    .hover_back {
      display: none;
      position: absolute;
      left: 22px;
      top: -46px;
      .hover_list {
        width: 124px;
        background: #ffffff;
        border-radius: 12px;
        margin-left: 30px;

        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
        .list_item {
          height: 40px;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          color: #717171;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
